import { render } from "./result-box.vue?vue&type=template&id=b8b8dba0&scoped=true"
import script from "./result-box.vue?vue&type=script&lang=js"
export * from "./result-box.vue?vue&type=script&lang=js"

import "./result-box.vue?vue&type=style&index=0&id=b8b8dba0&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b8dba0"]])

export default __exports__